<template>
  <v-container fluid id="tf-cases" class="white py-8 py-md-16">
    <v-container>

      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline font-weight-bold"
            :style="{ color: '#00695C' }"
            data-aos="fade-down"
          >
            CASOS REALES
          </span>
          <h2
            class="display-1 font-weight-bold primary--text mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Empresas de comercio exterior que ya operan
            con TradeFlow
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(caseStudy, index) in cases"
          :key="index"
          cols="12"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="String(300 + index * 100)"
        >
          <v-card class="tf-cases-card pa-6 h-100" elevation="3">
            <v-img
              class="rounded-lg mb-4"
              :alt="caseStudy.imageAlt"
              height="180"
              :src="caseStudy.image"
            >
              <template v-slot:placeholder>
                <v-skeleton-loader
                  type="image"
                  height="180"
                ></v-skeleton-loader>
              </template>
            </v-img>

            <div class="mb-4">
              <v-avatar
                size="60"
                :style="{ backgroundColor: '#00695C1A' }"
              >
                <v-icon
                  size="30"
                  :style="{ color: '#00695C' }"
                >
                  {{ caseStudy.icon }}
                </v-icon>
              </v-avatar>
            </div>

            <h3 class="text-h5 primary--text mb-3 font-weight-bold">
              {{ caseStudy.title }}
            </h3>
            <p
              class="text-body-1 greydark--text mb-4"
              style="line-height: 1.7;"
              v-html="caseStudy.description"
            ></p>

            <v-chip small color="success" text-color="white">
              <v-icon left small>{{ caseStudy.chipIcon }}</v-icon>
              {{ caseStudy.chipText }}
            </v-chip>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          cols="12"
          class="text-center"
          data-aos="fade-up"
          data-aos-delay="700"
        >
          <v-btn
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            depressed
            class="white--text"
            :style="{ backgroundColor: '#00695C' }"
            href="#tf-contact"
            rounded
          >
            Quiero Ver una Demo
          </v-btn>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFCases',
  data() {
    return {
      cases: [
        {
          title: 'Exportadora de Alimentos',
          // eslint-disable-next-line max-len
          description: '"Redujimos en <strong style="color:#00695C">60% el tiempo</strong> de armado de documentación de exportación y detectamos <strong style="color:#00695C">12 errores en pedimentos</strong> antes de presentarlos al SAT."',
          imageAlt: 'Caso Real - Exportadora de Alimentos — panel de métricas personales',
          image: '/img/cases/case-exportadora.svg',
          icon: 'mdi-food-apple',
          chipIcon: 'mdi-clock-fast',
          chipText: '60% menos tiempo',
        },
        {
          title: 'Importador de Insumos Industriales',
          // eslint-disable-next-line max-len
          description: '"Por primera vez tenemos <strong style="color:#00695C">visibilidad en tiempo real</strong> de cada pedimento. El control de costos de flete nos ahorró <strong style="color:#00695C">más de $180,000 MXN en el primer trimestre</strong>."',
          imageAlt: 'Caso Real - Importador de Insumos — gestiones críticas con prioridad',
          image: '/img/cases/case-importador.svg',
          icon: 'mdi-factory',
          chipIcon: 'mdi-eye-check',
          chipText: 'Visibilidad total',
        },
        {
          title: 'Agente Aduanal',
          // eslint-disable-next-line max-len
          description: '"Gestionamos 15 clientes desde una sola plataforma. <strong style="color:#00695C">-80% de mensajes por WhatsApp</strong> y <strong style="color:#00695C">-45% de errores</strong> en documentación de despacho."',
          imageAlt: 'Caso Real - Agente Aduanal — análisis de cuellos de botella',
          image: '/img/cases/case-agente.svg',
          icon: 'mdi-briefcase-check',
          chipIcon: 'mdi-message-minus',
          chipText: '80% menos WhatsApp',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-cases-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}

.tf-cases-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 105, 92, 0.15) !important;
}

</style>
